import React, { Component } from 'react'
import img from '../../images/room-svc/meals/cover_breakfast.png'
import img2 from '../../images/room-svc/meals/cover_lunch.png'
import img3 from '../../images/room-svc/meals/cover_dinner.png'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { CMSPath } from '../../config/constant'
import { changePage, selectedStoreItemType, getItemType, getSubItemType, getItemList } from '../../action/hcommerce'
import defaultImage from '../../images/cover_breakfast.png'
import { hCommButtonColor } from '../../JS/setColors'

class StoreItemTypeList extends Component {

    goToMainMenu = (nextPage, foodTime) => {
        this.props.changePage(nextPage);
        this.props.selectedStoreItemType(foodTime);
    }

    componentDidMount() {
        hCommButtonColor(this.props.menuColor)
        let sessionToken = localStorage.getItem('GuestJourneySessionToken');
        if (sessionToken) {

            this.props.getItemType(this.props.guestDetail, this.props.currentWidget.storeSku);
            // this.props.getSubItemType(this.props.guestDetail,74);
            // this.props.getItemList(this.props.guestDetail,294);
            //console.log("currentWidget", this.props.currentWidget.storeSku);
        }
    }
    render() {
        let imagePath;
        return (
            <div id="rs-main" class="movie-widgets" style={{ color: "inherit" }}>
                <h4 style={{ color: "inherit" }}>Room service</h4>
                <ul class="movie-widgets-list">
                    <li data-target="rs-order-list" onClick={() => { this.goToMainMenu("myOrder", "Breakfast") }}>
                        <a style={{ top: 0, borderRadius: "15px" }}>
                            <i class="fa fa-list"></i>
                            <span>My Orders</span>
                        </a>
                    </li>
                    {this.props.itemTypeList ?
                        this.props.itemTypeList.map((iterator) => {
                            if (iterator.storeItemTypeImages.length === 1) {
                                imagePath = `${CMSPath}${iterator.storeItemTypeImages[0].imagePath}`
                            } else {
                                iterator.storeItemTypeImages.map((images) => {
                                    if (images.imageType === "LARGE") {
                                        imagePath = encodeURI(`${CMSPath}${images.imagePath}`)
                                    }
                                })
                            }
                            if (iterator.storeItemTypeImages.length === 0) {
                                imagePath = defaultImage
                            }
                            return (
                                <li onClick={() => { this.goToMainMenu("StoreSubItemType", iterator) }}
                                    data-target="rs-menu-list"
                                    style={{
                                        background: `url(${imagePath}) center center no-repeat`,
                                        backgroundSize: "cover"
                                    }}>
                                    <a ><span>{iterator.typeName}</span></a>
                                </li>
                            )
                        }) : null
                    }
                </ul>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        itemTypeList: state.store.Hcommerce.itemTypeList,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        selectedStoreItemType,
        getItemType,
        getSubItemType,
        getItemList
    }
)(StoreItemTypeList);

/* <li onClick={() => { this.goToMainMenu("mainMenu", "Breakfast") }}
data-target="rs-menu-list"
style={{
    background: `url(${img}) center center no-repeat`,
    backgroundSize: "cover"
}}>
<a ><span>Breakfast</span></a>
</li>
<li onClick={() => { this.goToMainMenu("mainMenu", "Lunch") }}
data-target="rs-menu-list"
style={{
    background: `url(${img2}) center center no-repeat`,
    backgroundSize: "cover"
}}>
<a ><span>Lunch</span></a>
</li>
<li onClick={() => { this.goToMainMenu("mainMenu", "Dinner") }}
data-target="rs-menu-list"
style={{
    background: `url(${img3}) center center no-repeat`,
    backgroundSize: "cover"
}}>
<a ><span>Dinner</span></a>
</li> */